import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { logo } from '../../imagepath';
import { APP_NAME } from '../../../constants/constants';
import { getPrivacyPolicy } from '../../../api/legal.api';

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('bg-BG', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const PrivacyPolicy = () => {
    const [content, setContent] = useState('');
    const [updatedAt, setUpdatedAt] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchPrivacy = async () => {
            try {
                const response = await getPrivacyPolicy();
                setContent(response.content);
                setUpdatedAt(response.updatedAt);
            } catch (err) {
                setError('Грешка при зареждане на политиката за поверителност.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchPrivacy();
    }, []);

    return (
        <div className="main-wrapper">
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="card">
                            <div className="card-header bg-white border-bottom">
                                <div className="d-flex align-items-center justify-content-between">
                                    <Link to="/login" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                        <img src={logo} width="40" height="40" alt="" />
                                        <span style={{ marginLeft: '10px', fontSize: '20px', fontWeight: '500', color: '#2e37a4' }}>{APP_NAME}</span>
                                    </Link>
                                    {updatedAt && (
                                        <small className="text-muted">Последна актуализация: {formatDate(updatedAt)}</small>
                                    )}
                                </div>
                            </div>
                            <div className="card-body p-4">
                                {isLoading && (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Зареждане...</span>
                                        </div>
                                        <p className="mt-3 text-muted">Зареждане...</p>
                                    </div>
                                )}

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                {!isLoading && !error && (
                                    <div
                                        className="legal-content"
                                        dangerouslySetInnerHTML={{ __html: content }}
                                    />
                                )}
                            </div>
                            <div className="card-footer bg-white border-top text-center py-3">
                                <Link to="/login" className="btn btn-outline-primary me-2">
                                    Към вход
                                </Link>
                                <Link to="/register" className="btn btn-primary">
                                    Регистрация
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
